(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[410],{

/***/ 90075:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/categories/[category]",
      function () {
        return __webpack_require__(97953);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 97953:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(828);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _layouts_home__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(91511);
/* harmony import */ var _components_icon__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(72287);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _components_service_carousel_with_description__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(94435);
/* harmony import */ var uuid__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(25934);
/* harmony import */ var urql__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(92432);
/* harmony import */ var next_urql__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(61325);
/* harmony import */ var _utils_storage__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(44920);
/* harmony import */ var _graphql_queries_home_query__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(74508);
/* harmony import */ var _components_spinner__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(77429);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_9__);














var SingleCategory = function(props) {
    var ref, ref1, ref2, ref3, ref4, ref5;
    var ref6 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)((0,urql__WEBPACK_IMPORTED_MODULE_11__/* .useQuery */ .aM)({
        query: _graphql_queries_home_query__WEBPACK_IMPORTED_MODULE_7__/* .GetVendorServiceByCategory */ .J3,
        pause: !props.category,
        variables: {
            vendorServiceCategoryId: props.category
        }
    }), 1), categoryResult = ref6[0];
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_9___default()), {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                        children: "Inawo Vendors | Categories"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "title",
                        content: "Inawo Vendors | Categories"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "description",
                        content: "Inawo Vendors Categories"
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "w-full",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "w-full pt-8 flex justify-start items-center gap-2 text-inawo-black",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_4___default()), {
                                href: "/",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                    className: "p-1.5 bg-transparent transition hover:bg-gray-50 rounded-md",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_icon__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                        iconName: "arrowLeft"
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                className: "uppercase tracking-widest font-light font-sfpro text-base xs:text-lg",
                                children: !!((ref = categoryResult.data) === null || ref === void 0 ? void 0 : ref.getVendorServiceByCategory) ? (ref2 = (ref1 = categoryResult.data) === null || ref1 === void 0 ? void 0 : ref1.getVendorServiceByCategory[0]) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.category) === null || ref3 === void 0 ? void 0 : ref3.Name : ""
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "w-full flex flex-col justify-start items-start gap-4 mt-12",
                        children: categoryResult.fetching ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_spinner__WEBPACK_IMPORTED_MODULE_8__/* .Spinner */ .$, {}) : !!((ref4 = categoryResult.error) === null || ref4 === void 0 ? void 0 : ref4.message) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                            children: "An error occurred"
                        }) : !!((ref5 = categoryResult.data) === null || ref5 === void 0 ? void 0 : ref5.getVendorServiceByCategory) && categoryResult.data.getVendorServiceByCategory.map(function(item) {
                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_service_carousel_with_description__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                item: item,
                                priority: true
                            }, (0,uuid__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)());
                        })
                    })
                ]
            })
        ]
    });
};
SingleCategory.getLayout = function getLayout(page) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_layouts_home__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        children: page
    });
};
var __N_SSP = true;
/* harmony default export */ __webpack_exports__["default"] = ((0,next_urql__WEBPACK_IMPORTED_MODULE_13__/* .withUrqlClient */ .X)(function(_ssr) {
    return {
        url: "https://production.inawo.live/query",
        requestPolicy: "cache-and-network",
        fetchOptions: function() {
            return {
                headers: {
                    "x-user-token": (0,_utils_storage__WEBPACK_IMPORTED_MODULE_6__/* .getAccessCookie */ .tN)() ? "".concat((0,_utils_storage__WEBPACK_IMPORTED_MODULE_6__/* .getAccessCookie */ .tN)()) : ""
                }
            };
        }
    };
}, {
    ssr: false
})(SingleCategory));


/***/ }),

/***/ 74508:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "J3": function() { return /* binding */ GetVendorServiceByCategory; },
/* harmony export */   "Pz": function() { return /* binding */ GetFeaturedVendorServices; },
/* harmony export */   "Tw": function() { return /* binding */ GetInawoVendorServiceCategory; },
/* harmony export */   "n5": function() { return /* binding */ User; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var urql__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(26997);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  query GetInawoVendorServiceCategory {\n    getInawoVendorServiceCategory {\n      id\n      Name\n      Description\n      Images\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  query GetVendorServiceByCategory(\n    $vendorServiceCategoryId: UUID!\n    $page: Int\n    $pageSize: Int\n  ) {\n    getVendorServiceByCategory(\n      vendorServiceCategoryId: $vendorServiceCategoryId\n    ) {\n      id\n      interests\n      vendors_id\n      price {\n        currency\n        amount\n      }\n      vendor_service_category_id\n      category {\n        id\n        Name\n      }\n      service_name\n      pinned\n      description\n      phone_number\n      rating\n      email\n      address\n      showcase(page: $page, pageSize: $pageSize) {\n        id\n        vendors_id\n        vendor_service_id\n        vendor_service_category_id\n        media\n      }\n    }\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  query GetFeaturedVendorServices($page: Int, $pageSize: Int) {\n    getFeaturedVendorServices {\n      id\n      vendors_id\n      vendor_service_category_id\n      service_name\n      pinned\n      category {\n        Name\n      }\n      showcase(page: $page, pageSize: $pageSize) {\n        id\n        media\n        name\n        vendor_service_id\n        vendors_id\n        vendor_service_category_id\n      }\n    }\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  query User {\n    user {\n      id\n      image\n      email\n      phone_number\n      first_name\n      last_name\n      title\n      uuid\n    }\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}

var GetInawoVendorServiceCategory = (0,urql__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject());
var GetVendorServiceByCategory = (0,urql__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject1());
var GetFeaturedVendorServices = (0,urql__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject2());
var User = (0,urql__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject3());


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [379,88,655,675,453,237,568,774,888,377], function() { return __webpack_exec__(90075); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);